import { useCallback } from "react";
import { PublicAssetFrontendApi$AssetComponentDto } from "@/custolink-transpiled_by_server/bc.asset_interaction.api_methods";
import { useTranslation } from "react-i18next";

export default function useAssetViewTranslator() {

  const { t } = useTranslation();

  const translateComponentNames = useCallback(
    (comps: PublicAssetFrontendApi$AssetComponentDto[]) => {
      return comps.map((c) => {
        const comp = { ...c };
        if (c.i18nNameKey != null) {
          comp.name = t("components.titles." + c.i18nNameKey);
        }
        return comp;
      });
    },
    [t],
  );

  return {
    translateNames: translateComponentNames,
  };
}

